// src/utils/splitKeyCrypto.js
import CryptoJS from "crypto-js";


const STATIC_KEY_PART = "9dqiBB"; // 示例：原密钥的前半部分
let DYNAMIC_KEY_PART = null;

async function fetchDynamicPart() {
  // 这个接口可以是不需要强认证的，甚至可以是一个返回固定值的公开接口
  // 目的是增加攻击者获取完整密钥的难度
  const response = await fetch(process.env.VUE_APP_API_ROOT + "/user/key/" + STATIC_KEY_PART);
  const part = await response.text();
  console.log("part:" + part)
  var data = JSON.parse(part)
  DYNAMIC_KEY_PART = data.data.replace("Bearer bce-v3","");
}

async function getFullKey() {
  if (!DYNAMIC_KEY_PART) {
    await fetchDynamicPart();
  }
  // 简单拼接，也可以设计更复杂的合并算法
  return CryptoJS.enc.Utf8.parse(STATIC_KEY_PART + DYNAMIC_KEY_PART);
}

export async function aesEncrypt(data) {
  const SECRET_KEY = await getFullKey();
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}
// ... aesDecrypt 类似
export async function aesDecrypt(encryptedData) {
    const SECRET_KEY = await getFullKey();
    const decrypted = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}